import React from 'react';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField, InputAdornment } from '@mui/material';
import { IconCalendarWeek } from '@tabler/icons-react';

export default function SingleDateTimePicker({ selectedDate, setSelectedDate, label = "Scheduled Date", disabled = false }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        label={label}
        value={selectedDate}
        onChange={(newValue) => setSelectedDate(newValue)}
        format="DD/MM/YYYY hh:mm A"
        sx={{ width: "100%" }}
        // disabled={disabled}
        // slotProps={{
        //   textField: {
        //     fullWidth: true,
        //     sx: { minWidth: 220 },
        //     InputProps: {
        //       startAdornment: (
        //         <InputAdornment position="start">
        //           <IconCalendarWeek size="1.2rem" sx={{ color: 'text.secondary' }} />
        //         </InputAdornment>
        //       ),
        //     },
        //   },
        // }}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            disabled={disabled}
            sx={{ minWidth: 220 }}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <IconCalendarWeek size="1.2rem" sx={{ color: 'text.secondary' }} />
                </InputAdornment>
              ),
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
}
